import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../api/ApiRoutes";
import type { AxiosInstance } from "axios";

export type PatchCasinoConfigurationGameDetailsPayload = {
  provider: string;
  game_id: string;
  display_name?: string;
  clear_thumbnail?: boolean;
  custom_image?: string;
};

export async function patchCasinoConfigurationGameDetails(
  axiosInstance: AxiosInstance,
  payload: PatchCasinoConfigurationGameDetailsPayload,
) {
  const { data: responseBody } = await axiosInstance.patch(
    API_ROUTES.PATCH_CASINO_CONFIGURATION_GAME_DETAILS,
    payload,
  );
  if (responseBody?.success === false) {
    throw new Error(responseBody?.message || "Game update rejected");
  }
  return responseBody;
}

export async function fetchPatchCasinoConfigurationGameDetails(
  payload: PatchCasinoConfigurationGameDetailsPayload,
) {
  const token = JSON.parse(localStorage.getItem("token") ?? "null");
  const legacyInstance = createPrivateAdminPanelInstance(token?.AccessToken);
  const gamesAdminInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
    false,
  );

  const {
    provider,
    game_id,
    display_name,
    custom_image,
    clear_thumbnail,
  } = payload;

  const hasLegacyFields = clear_thumbnail !== undefined;

  const v3PatchBody: Record<string, unknown> = {};
  if (display_name !== undefined) v3PatchBody.name = display_name;
  if (custom_image !== undefined) v3PatchBody.custom_image = custom_image;

  if (Object.keys(v3PatchBody).length > 0) {
    const patchPath = `${API_ROUTES.GET_ADMIN_GAMES}/${encodeURIComponent(provider)}/${encodeURIComponent(game_id)}`;
    const { data: responseBody } = await gamesAdminInstance.patch(
      patchPath,
      v3PatchBody,
    );
    if (responseBody?.success === false) {
      throw new Error(responseBody?.message || "Game update rejected");
    }
  }

  if (!hasLegacyFields) {
    return { success: true };
  }

  const v3Succeeded = Object.keys(v3PatchBody).length > 0;
  try {
    return await patchCasinoConfigurationGameDetails(legacyInstance, {
      provider,
      game_id,
      clear_thumbnail,
    });
  } catch (err) {
    if (v3Succeeded) {
      throw new Error(
        "Name/image saved. Failed to update game type / metadata: " +
          ((err as Error).message || "unknown error"),
      );
    }
    throw err;
  }
}
